<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-dialog
        v-model="sns_flg"
        max-width="800px"
    >
        <v-card
            tile
            flat
            width="800px"
            min-height="300px"
        >
            <v-toolbar
                tile
                flat
                color="#E11D31"
                dark
            >
                <v-toolbar-title>
                    SNS等アカウント一覧
                </v-toolbar-title>
                <v-spacer />
                <v-icon
                    @click="sns_flg=false"
                >
                    mdi-close
                </v-icon>
            </v-toolbar>
            <v-card-text class="mt-3">
                <v-card flat outlined>
                    <v-card-text>
                        <v-icon>mdi-plus</v-icon>をクリックするとメディアリストの宛先候補へ追加できます。メールアドレスのみ追加できます。
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-text>
                <table class="common-table" >
                 <thead class="common-table__head">
                  <tr class="common-table__head-row">
                   <th class="common-table__head-title -tx-left">アカウント一覧</th>
                   <th class="common-table__head-title"></th>
                   <th class="common-table__head-title"></th>
                  </tr>
                 </thead>
                 <tbody class="common-table__body">
                  <tr class="common-table__body-row"  v-for="site,index in sns_list" :key="index">
                   <td class="common-table__body-data -tx-left -account">{{ site.account_name }}</td>
                   <td class="common-table__body-data">{{ site.label }}</td>
                   <td class="common-table__body-data -account -logo -tx-left">
                        <a  v-if="site.mail_address != null" :href="'mailto:'+site.mail_address"><img src="rel_image/mail.svg" v-if="site.mail_address != null"></a>
                        <a v-if="site.twitter" :href="site.twitter" target="_blunk"><img src="img/ico_twitter.svg" style="background-color:black"></a>
                        <a v-if="site.instagram" :href="site.instagram" target="_blunk"><img src="img/instagram-logo-svgrepo-com.svg"></a>
                        <a v-if="site.facebook" :href="site.facebook" target="_blunk"><img src="img/facebook-icon.svg"></a>
                        <a v-if="site.youtube" :href="site.youtube" target="_blunk"><img src="img/youtube-icon.svg"></a>
                        <a v-if="site.blog" :href="site.blog" target="_blunk"><img src="rel_image/site.svg"></a>
                   </td>
                    <td>
                        <v-icon v-if="site.mail_address != null" class="mx-1" @click="listcand(site)">
                            mdi-plus
                        </v-icon>
                    </td>
                  </tr>
                 </tbody>
                </table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            site_id : "",
            sns_flg : false,
            sns_list : [],
            media_detail : null,
        };
    },
    methods : {
        listcand : async function(obj){
            let params = new URLSearchParams();
            params.append('site_id',obj.site_id);
            params.append('contact_item',obj.mail_address);
            params.append('addressee',obj.account_name);
            params.append('mode',1);
            await axios.post("/api/media/set_media_list",params)
            .then(response => {
				this.$store.commit("mediacand/set_candlist",response.data);
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        
        },
        open : function(id){
            this.get_list(id);
        },
        get_list : async function(site_id){
            let params = new URLSearchParams();
            params.append('site_id',site_id);

            await axios.post("/api/media/get_sns_account",params)
            .then(response => {
                this.media_detail = response.data.media_detail[0];
                this.sns_list   = response.data.account_list;
                this.sns_flg = true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
}
</script>
